/* eslint-disable no-use-before-define */
import { useEffect, useState } from 'react';
import { FormControl } from '@mui/material';
import PropTypes from 'prop-types';

import { REGISTER_STEPS } from '../../../../../constants/registerSteps';
import ButtonComponent from '../../../../../components/ButtonComponent';
import Input from '../../../../../components/Form/Input';
import styles, { FormContainer, Footer } from '../../styles';
import { isValidEmail } from '../../../../../utils';
import { errorMessages, passwordIconFactory } from './helpers';
import useFormStep from './useFormStep';
import StepsHeadline from './StepsHeadline';
import GoogleLoginButton from '../../../../../components/GoogleLoginButton';

const formStep = REGISTER_STEPS.SIGN_IN_INFO;
export default function SignInInfo({ handleNext }) {
  const [showPassword, setShowPassword] = useState(false);
  const passwordIcon = passwordIconFactory(showPassword, setShowPassword);
  const [pendingGoogleLogin, setPendingGoogleLogin] = useState(false);

  const validateField = (name, value) => {
    if (!value?.trim()) return errorMessages.MANDATORY_FIELD;

    switch (name) {
      case 'email':
        if (!isValidEmail(value)) return 'E-mail inválido';
        break;
      case 'password':
        if (value.length < 6) return 'Senha deve ter pelo menos 6 caracteres';
        if (value.length > 200) return 'Senha deve ter no máximo 200 caracteres';
        break;
      case 'passwordConfirmation':
        if (value !== form.password) return 'As senhas não coincidem';
        break;
      default:
        return '';
    }
    return '';
  };

  const {
    form,
    formErrors,
    isLoading,
    inputRef,
    handleChange,
    handleSubmit,
    isStepValid,
  } = useFormStep(formStep, validateField, handleNext);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <FormContainer onSubmit={handleSubmit}>
      <StepsHeadline />

      <FormControl sx={styles.textField} variant="standard">
        <Input
          ref={inputRef}
          placeholder="E-mail"
          value={form.email}
          onChange={handleChange}
          type="email"
          name="email"
          autoComplete="new-email"
          inputProps={{ maxLength: 200 }}
          error={!!formErrors.email}
          helperText={formErrors.email}
          disabled={isLoading}
        />
      </FormControl>

      <FormControl sx={styles.textField} variant="standard">
        <Input
          placeholder="Senha"
          value={form.password}
          onChange={handleChange}
          type={showPassword ? 'text' : 'password'}
          name="password"
          autoComplete="new-password"
          inputProps={{ maxLength: 200 }}
          error={!!formErrors.password}
          helperText={formErrors.password}
          InputProps={passwordIcon}
          disabled={isLoading}
        />
      </FormControl>

      <FormControl sx={styles.textField} variant="standard">
        <Input
          placeholder="Confirme sua senha"
          value={form.passwordConfirmation}
          onChange={handleChange}
          type={showPassword ? 'text' : 'password'}
          name="passwordConfirmation"
          autoComplete="new-password"
          inputProps={{ maxLength: 200 }}
          error={!!formErrors.passwordConfirmation}
          helperText={formErrors.passwordConfirmation}
          InputProps={passwordIcon}
          disabled={isLoading}
        />
      </FormControl>

      <Footer>
        <ButtonComponent
          type={isLoading ? 'button' : 'submit'}
          size="large"
          disabled={!isStepValid() || isLoading}
          loading={isLoading}
        >
          Próximo
        </ButtonComponent>

        <GoogleLoginButton
          isLoading={pendingGoogleLogin}
          setLoading={setPendingGoogleLogin}
          labelButton={'Cadastrar com Google'}
        />
      </Footer>
    </FormContainer>
  );
}

SignInInfo.propTypes = {
  handleNext: PropTypes.func.isRequired,
};
